/* ============
 * Mutations for the formalities module
 * ============
 *
 * The mutations that are available on the
 * formalities module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setUser (state, payload) {
    state.user = payload.data
  },
  clear (state) {
    state.user = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/formalities/mutations.js